module.exports = __webpack_public_path__ + "static/media/03.8a6f2c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/03.png
// module id = 26
// module chunks = 0